import { ConfigRoutes } from "@shared/models/general/utils.interface";

interface AccesosContabilidad {
  CONFIGURACION: ConfigRoutes;
  CONFIGURACION_OPERACIONES: ConfigRoutes;
  CONFIGURACION_TIPO_ANALITICA: ConfigRoutes;
  CONFIGURACION_PROYECTOS: ConfigRoutes;
  CONFIGURACION_CENTRO_COSTO: ConfigRoutes;
  CONFIGURACION_LIBROS_CONTABLES: ConfigRoutes;
  CONFIGURACION_CUENTAS_POR_LIBROS: ConfigRoutes;
  CONFIGURACION_TIPO_DOCUMENTO: ConfigRoutes;
  CONFIGURACION_MOTIVOS_DESTINO: ConfigRoutes;
  CONFIGURACION_CHEQUES: ConfigRoutes;
  CONFIGURACION_UBICACIONES: ConfigRoutes;
  CONFIGURACION_CIERRE_CONTABLE: ConfigRoutes;
}

interface ModuloContabilidad {
  ID: number
  ACCESOS: AccesosContabilidad
}

const pathModulo = '/contabilidad/'

export const MODULO_CONTABILIDAD: ModuloContabilidad = {
  ID: 6,
  ACCESOS: {
    CONFIGURACION: { TITLE: "Configuración", ACCESS: 1000, PATH_MODULE: pathModulo, ROUTE: `configuracion`, DESCRI: 'Configuracion del modulo de contabilidad' },
    CONFIGURACION_OPERACIONES: { TITLE: "Operaciones", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `operaciones`, DESCRI: 'Configuracion de operaciones' },
    CONFIGURACION_TIPO_ANALITICA: { TITLE: "Tipos de analítica", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `tipo-analitica`, DESCRI: 'Configuracion de tipos de analitica' },
    CONFIGURACION_PROYECTOS: { TITLE: "Proyectos", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `proyectos`, DESCRI: 'Configuracion de proyectos' },
    CONFIGURACION_CENTRO_COSTO: { TITLE: "Centro de costo", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `centro-costo`, DESCRI: 'Configuracion de centro de costo' },
    CONFIGURACION_LIBROS_CONTABLES: { TITLE: "Libros contables", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `libros-contables`, DESCRI: 'Configuracion de libros contables' },
    CONFIGURACION_CUENTAS_POR_LIBROS: { TITLE: "Cuentas por libros", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `cuentas-por-libros`, DESCRI: 'Configuracion de cuentas por libros' },
    CONFIGURACION_TIPO_DOCUMENTO: { TITLE: "Tipos de documento", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `tipo-documento`, DESCRI: 'Configuracion de tipos de documento' },
    CONFIGURACION_MOTIVOS_DESTINO: { TITLE: "Motivos de destino", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `motivos-destino`, DESCRI: 'Configuracion de motivos de destino' },
    CONFIGURACION_CHEQUES: { TITLE: "Cheques", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `cheques`, DESCRI: 'Configuracion de cheques' },
    CONFIGURACION_UBICACIONES: { TITLE: "Ubicaciones", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `ubicaciones`, DESCRI: 'Configuracion de ubicaciones' },
    CONFIGURACION_CIERRE_CONTABLE: { TITLE: "Cierre contable", ACCESS: 201, PATH_MODULE: `${pathModulo}configuracion/`, ROUTE: `cierre-contable`, DESCRI: 'Configuracion de cierre contable' },
  }
};